<template>
    <div class="card-match" :class="statusClass()">
<!--      <pre ><code>{{ match  }}</code></pre>-->
        <router-link class="card-match-link" v-if="match.team1.name!='TBA' && match.team2.name!='TBA'" :to="{ name: (isScheduled() ? 'matchDetail.Teams' :'matchDetail.Scorecard'), params: { match: match.slug } }" aria-label="matchCard"></router-link>
        <div class="card-match-head">
            <div class="match-head-info">
                <!--<time v-if="isScheduled()" class="time" :datetime="match.gmt_datetime | formatDate('YYYY-MM-DD')">
                                {{ match.gmt_datetime | formatDate('hh:mm A') }}
                        </time>-->
                <span class="badge" :class="badgeClass">
                    {{ match.badgeStatus == 'Live' ? 'Live' : match.status }}
                </span>
                <ul>
                    <li v-if="match.badgeStatus != 'Live'">{{ match.gmt_datetime | formatDate($route.name == 'myMatches' ?'DD MMM YYYY hh:mm A': 'hh:mm A') }}</li>
                    <!--<li>{{ match.matchtype }}</li>-->
                    <li>{{ match.matchno }}</li>
                </ul>
            </div>

            <span class="star-btn" >
                <span class="crr-info runrates" v-if="match.runrate && !isFinished()"
                      >CRR : <span class="runrate">{{ match.runrate }}</span></span
                >
                <!-- <i class="ico-star"></i> -->
            </span>
        </div>
        <div class="card-match-body">
            <div class="team-info-wrp">
                <span v-if="match.status !='Finished'" class="notification-btn" :class="{ active: $store.getters.isMatchFavourited(match.slug) }" @click="toggleFavourite(match.slug)"><i class="ico-bell"></i></span>
                <ul class="team-info">
                    <li :class="{ active: match.winner == 1 }">
                        <span class="team-info-name">
                            <span class="name">{{ match.team1.name }}</span>
                            <i v-show="isLive() && match.batting_team_id == match.team1.id" class="ico-bat"> <img :src="$vuePublicPath('/images/bat.svg')" width="19" height="19" alt="bat"></i>
                            <i v-show="isLive() && match.bowling_team_id == match.team1.id" class="ico-ball"><img :src="$vuePublicPath('/images/cricket_Ball.png')" width="12" height="12" alt="ball"></i>
                        </span>
                        <span class="team-info-score">
                            {{ match.ht_score || '-' }}
                            <span class="over">{{ overs('team1') }}</span>
                        </span>
                    </li>
                    <li :class="{ active: match.winner == 2 }">
                        <span class="team-info-name">
                            <i v-show="isLive() && match.batting_team_id == match.team2.id" class="ico-bat"><img :src="$vuePublicPath('/images/bat.svg')" width="19" height="19" alt="bat"></i>
                            <i v-show="isLive() && match.bowling_team_id == match.team2.id" class="ico-ball"><img :src="$vuePublicPath('/images/cricket_Ball.png')" width="12" height="12" alt="ball"></i>
                            <span class="name">{{ match.team2.name }}</span>
                        </span>
                        <span class="team-info-score">
                            {{ match.at_score || '-' }}
                            <span class="over">{{ overs('team2') }}</span>
                        </span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="card-match-tfoot" v-if="match.activeBatsman1 && (isLive() || isStumps())">

            <div class="betting-info">
                <!-- <strong class="title-tag">BM:</strong> -->
                <div class="bastmain-wrap">
                    <span class="bastmain d-none d-md-block" v-if="match.activeBatsman1 && match.activeBatsman1.player">
                        {{ match.activeBatsman1.player.name }} {{ match.activeBatsman1.score }} ({{ match.activeBatsman1.balls }})
                    </span>
                    <span class="bastmain d-md-none" v-if="match.activeBatsman1 && match.activeBatsman1.player">
                        {{ match.activeBatsman1.player.short_name }} {{ match.activeBatsman1.score }} ({{ match.activeBatsman1.balls }})
                    </span>
                    <span class="bastmain d-none d-md-block" v-if="match.activeBatsman2 && match.activeBatsman2.player">
                        {{ match.activeBatsman2.player.name }} {{ match.activeBatsman2.score }} ({{ match.activeBatsman2.balls }})
                    </span>
                    <span class="bastmain d-md-none" v-if="match.activeBatsman2 && match.activeBatsman2.player">
                        {{ match.activeBatsman2.player.short_name }} {{ match.activeBatsman2.score }} ({{ match.activeBatsman2.balls }})
                    </span>
                     <a type="button" v-if="match.player_batting_inning" ><span  class="badge badge-success"  @click="batting(match.slug,match.player_batting_inning)">Batting</span></a>
                     <a type="button" v-if="match.player_bowling_inning" ><span class="badge badge-success"  @click="bowling(match.slug,match.player_bowling_inning)">Bowling</span></a>
                </div>

            </div>

            <!-- <div class="bowling-info-wrap">
                    <div class="bowling-info-left" v-if="match.lastOver.length != 0">
                            <strong class="title-tag">LO:</strong>
                            <ul class="bowl-info">
                                    <li
                                            :class="{ six: ball.d_score == '6', four: ball.d_score == '4', wicket: ball.d_score.startsWith('W') }"
                                            v-for="ball in match.lastOver"
                                            :key="ball.id"
                                    >
                                            {{ ball.d_score.startsWith('W') ? 'W' : ball.sc }}
                                    </li>
                            </ul>
                    </div>
                    <span class="crr-info" v-if="match.runrate"
                            >CRR<span>{{ match.runrate }}</span></span
                    >
            </div> -->
        </div>
        <div class="card-match-tfoot" v-if="isFinished()">

            <div class="finesh-inf">
                <div class="finesh-inf-text">
                    <p>{{ match.comment }}</p>

                </div>
                <div class="popup-text">
                     <a type="button" v-if="match.player_batting_inning"><span class="badge badge-success"  @click="batting(match.slug,match.player_batting_inning)">Batting</span></a>
                    <a type="button" v-if="match.player_bowling_inning"><span class="badge badge-success"  @click="bowling(match.slug,match.player_bowling_inning)">Bowling</span></a>
                </div>
                <router-link v-if="match.has_video" class="video-link-btn" :to="{ name:'matchDetail.Videos', params: { match: match.slug } }" aria-label="camera">
                <i class="ico-camera"></i>
                </router-link>

            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
    export default {
        props: ['match'],

        data() {
            return {
                badgeClass: '',
                d:0,
                dta:0,
                totalballs:'',
                totalovers:'',
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                this.main();
            }
        },
        mounted() {

            this.main();
        },
        beforeDestroy() {
            this.$root.$off('MatchUpdated')
        },

        methods: {
            main() {
                this.badgeClass = this.isLive()
                        ? 'badge-danger'
                        : this.isStumps()
                        ? 'badge-success'
                        : this.isCancelled()
                        ? 'badge-cancel'
                        : 'badge-dark'
                var _this = this;
                _this.$root.$on('MatchUpdated', function (data) {
                    if (_this.match && data.match_id == _this.match.id) {
                        global.clickedElement = null;
                        _this.$parent.getMatches();
                    }
                });
            },
            isLive() {
                return this.match.badgeStatus == 'Live'
            },

            isFinished() {
                return this.match.badgeStatus == 'Finished'
            },

            isStumps() {
                return this.match.badgeStatus == 'Stumps'
            },

            isCancelled() {
                return this.match.badgeStatus == 'Cancelled'
            },

            isScheduled() {
                return this.match.badgeStatus == 'Scheduled'
            },

            statusClass() {
                return this.isLive() || this.isFinished() || this.isStumps() ? this.match.badgeStatus.toLowerCase() : ''
            },

            toggleFavourite(matchSlug) {
                this.$store.commit(this.$store.getters.isMatchFavourited(matchSlug) ? 'removeFavouriteMatch' : 'addFavouriteMatch', matchSlug)
            },
            batting(match_slug,inningorders)
            {
               // this.$router.replace({ path: '/player/'+this.$route.params.player+'/match/'+match_slug+'/inning/'+inningorders+'/type/batsman'});
                this.$emit('batting', {
                players: this.$route.params.player,
                playermatchslug:match_slug,
                inningsorder: inningorders,
                })
            },
            bowling(match_slug,inningorders)
            {
                // this.$router.replace({ path: '/player/'+this.$route.params.player+'/match/'+match_slug+'/inning/'+inningorders+'/role/bowler'});
                this.$emit('bowling', {
                players: this.$route.params.player,
                playermatchslug:match_slug,
                inningsorder: inningorders,
                })
            },
            overs(team) {
                if (!this.match[team])
                    return ''
                let innings = this.match.innings.filter(inning => inning.team_id == this.match[team].id)
                return innings.length ? `(${innings[innings.length - 1].overs} ${this.match.matchtype == '100 Ball Match' ? 'balls' : 'Ov'})` : ''
            }
        }
    }
</script>
<style lang="scss">
    .popup-text a span{
        position: relative;
        z-index: 2;
        color: white;
            padding: 6px;
    }
    .bastmain-wrap a span{
        position: relative;
        z-index: 2;
        color: white;
            padding: 6px;
    }
</style>
